declare const __URL_BACKEND__: string;
declare const __HOST_NAME__: string;

export const urlBackend = __URL_BACKEND__;
export const hostName = __HOST_NAME__ ? __HOST_NAME__ : '';
export const PerPage = 100;
